import { useQuery } from '@tanstack/react-query';
import { getAnnouncementViewsPerDay } from '../../../api/announcements.api';
import { queryKeys } from '../../../api/queryKeys';

/**
 * The admin's own zone, so "today" on the chart is the day they are in. Read
 * here rather than from `getTimeZone` in helpers.tsx, which closes the
 * helpers -> routes -> adminPages cycle.
 */
const timezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;

/** Views, viewers and dismissals per day, the last `days` days, oldest first. */
export const useAnnouncementViewsPerDay = (id: number, days: number) => {
  const query = useQuery({
    queryKey: queryKeys.admin.announcements.viewsPerDay(id, days),
    queryFn: async () =>
      (await getAnnouncementViewsPerDay(id, { days, timezone: timezone() }))
        .data.data ?? [],
  });

  return { days: query.data ?? [], isLoading: query.isLoading };
};
